import React from 'react';
import { SpacerRow, Grid, NumberInput, TextInput } from 'ui-toolkit';
import { IUnderwriterRemittanceData } from '../../../../types/order/escrow/IUnderwriterRemittanceData';
import { ICDV3ViewItem } from '../../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { generateDisplayLabel } from '../../../../ui-toolkit/cdItems/data/generateDisplayLabel';

export interface IEscrowRemittanceACHItemProps {
  remittance: IUnderwriterRemittanceData;
  cdItem: ICDV3ViewItem;
}

export const RemittanceItem: React.FC<IEscrowRemittanceACHItemProps> = ({ remittance, cdItem }) => {
  const remittanceAmount = remittance.underwriterFeeAmountCents / 100;
  const remittanceCDItemLabel = generateDisplayLabel(cdItem);
  return (
    <>
      <SpacerRow />
      <Grid columnCount={4}>
        <div>
          <label>Memo</label>
          <div>
            <TextInput disabled value={remittanceCDItemLabel || undefined} />
          </div>
        </div>
        <div>
          <label>Amount</label>
          <div>
            <NumberInput value={remittanceAmount} disabled mode={`currency`} prefix={`$`} />
          </div>
        </div>
        <div>
          <label>Payee Category</label>
          <div>
            <TextInput disabled value={`Third Party`} />
          </div>
        </div>
        <div />
      </Grid>
    </>
  );
};
